import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { OfferType } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonEightVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant8',
  styleUrl: './variant8.component.scss',
  templateUrl: './variant8.component.html',
  imports: [SafePipe, RewardPipe, ButtonComponent, VariableReplacementPipe],
})
export class Variant8Component extends SelectionButtonBaseClass {
  protected readonly OfferType: typeof OfferType = OfferType;
  config = input.required<SelectionButtonEightVariantConfig>();
}
